import { useEffect } from 'react';

interface UseAddClientEffectsProps {
  fetchData(): void;
  initSelectedTags(): void;
}

export const useAddClientEffects = ({
  fetchData,
  initSelectedTags,
}: UseAddClientEffectsProps) => {
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    initSelectedTags();
  }, [initSelectedTags]);
};
